import { useQuery } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";
interface VehicleBrand {
  name: string;
  id: string;
}

const fetchVehicleBrands = async (): Promise<VehicleBrand[]> => {
  const response = await httpRequest.get<VehicleBrand[]>(`/vehicle/makes`);
  return response.data;
};

export const useFetchVehicleBrands = () => {
  return useQuery<VehicleBrand[]>({
    queryKey: ["vehicleBrands"],
    queryFn: () => fetchVehicleBrands(),
  });
};
